import { useTranslation } from "react-i18next";

export default function ReviewSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="flex-1 w-full">
          <div className="rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Young%20entrepreneur%20woman%20casually%20dressed%20sitting%20cross%20legged%20on%20modern%20sofa%20with%20laptop%20open%20showing%20colorful%20dashboard%20charts%20bright%20airy%20loft%20apartment%20with%20large%20windows%20and%20indoor%20plants%20natural%20daylight%20lifestyle%20editorial%20photography%20genuine%20expression%20warm%20atmosphere&width=600&height=600&seq=review-img-v2&orientation=squarish"
              alt="Professional using Hipobuy Spreadsheet"
              className="w-full h-auto object-cover object-top"
              width={600}
              height={600}
            />
          </div>
        </div>
        <div className="flex-1 w-full">
          <span className="text-sm text-foreground-500 font-body">{t("home.review.label")}</span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mt-2 mb-6 font-heading">
            <span className="text-foreground-900">Le meilleur</span>
            <br />
            <span className="text-foreground-400">spreadsheet mode</span>
          </h2>
          <p className="text-base text-foreground-700 leading-relaxed mb-6 font-body italic">
            &ldquo;{t("home.review.text")}&rdquo;
          </p>
          <p className="text-sm font-bold text-foreground-900 font-body">
            — {t("home.review.author")}
          </p>
        </div>
      </div>
    </section>
  );
}